import React from 'react';

import type { IUser } from '../../types';

import { Wrapper, WrapperCard, WrapperCards, WrapperName } from './styled';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import Link from '@/presentation/reusables/Link';

interface IProps {
  user?: IUser;
}
const ProfileOptions = ({ user }: IProps) => (
  <Wrapper>
    <WrapperName>
      {user?.name ?? '-'}
      {user?.isGraduated && <span>Egresado</span>}
    </WrapperName>
    <WrapperCards>
      <WrapperCard>
        <h4>Código UTP</h4>
        <span>{user?.studentCode ?? '-'}</span>
      </WrapperCard>
      <WrapperCard>
        <h4>Carrera</h4>
        <span style={{ textTransform: 'capitalize' }}>
          {user?.program ?? '-'}
        </span>
      </WrapperCard>
      <WrapperCard>
        <h4>Modalidad</h4>
        <span>{user?.modality ?? '-'}</span>
      </WrapperCard>
      <WrapperCard>
        <h4>Campus</h4>
        <span>{user?.campus?.replace(/campus virtual/gi, 'UTP') ?? '-'}</span>
      </WrapperCard>
      <WrapperCard>
        <h4>Correo UTP</h4>
        <span>
          {user?.studentCode ? `${user.studentCode}@utp.edu.pe` : '-'}
        </span>
      </WrapperCard>
    </WrapperCards>
    <WarningMessage
      message={
        <>
          Si los datos mostrados contienen errores, registra una{' '}
          <Link
            linkType="internal"
            url="/tramites/ticketera/registro?v=TA0001"
            linkName="solicitud de SAE."
          />
        </>
      }
      styledProps={{ background: '#D5E5F0', padding: '16px' }}
    />
  </Wrapper>
);

export default ProfileOptions;
